var map = {
	"./alcorblack.svg": 381,
	"./alcorblack2.svg": 978,
	"./alcorwhite.svg": 382,
	"./alcorwhite2.svg": 979,
	"./anchor.svg": 577,
	"./bloks_logomark.svg": 845,
	"./coffe.svg": 980,
	"./greymass.svg": 981,
	"./keycat.svg": 982,
	"./ledger.svg": 983,
	"./lynx.svg": 984,
	"./mywish.svg": 985,
	"./proton_wallet.svg": 986,
	"./scatter.svg": 987,
	"./simpleos.svg": 988,
	"./tokenswap.svg": 989,
	"./wax.svg": 578
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 416;